import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { Login } from '@df/session/login/login.interfaces';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { CheckboxComponent } from 'projects/app-default/src/app/ui/form/checkbox';
import { InputWrapBodyDirective } from 'projects/app-default/src/app/ui/form/input-wrap-body.directive';
import { InputWrapComponent } from 'projects/app-default/src/app/ui/form/input-wrap.component';
import { FormWizardStepAbstract } from '../../../../../ui/form/wizard/step/form-wizard-step.abstract';
import { NLoginViewLayout } from '../../../../view/layout/login-view-layout.interface';
@Component({
    selector: 'login-form-trade-step-6',
    templateUrl: './login-form-trade-step-6.component.html',
    standalone: true,
    imports: [
        TranslationModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        MuiInputDirective,
        FormsModule,
        CheckboxComponent,
        ICmsClientModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormTradeStep6Component extends FormWizardStepAbstract {
    @Input({
        required: true
    })
    data!: Login.IRegisterFormData;
    
    @Input()
    content?: NLoginViewLayout.ILoginViewLayoutContent;
}
